function toHttps(url: string): string {
  return url && url.includes('http:') ? url.replace(/http:/g, 'https:') : url;
}

export default toHttps;
